module.exports = __webpack_public_path__ + "img/116.54c028d9.png";